export default "__VITE_ASSET__DlOC0_7n__"